import BenefitBlock from './BenefitBlock';

export default BenefitBlock;
